import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";
import { getCapHeadersConfig } from "@app/dashboard/utils/capToken";

export const submitBulkPaymentLink = async ({
  amountCents,
  useFixedAmount,
  bulkCustomers,
  paymentMethods,
  saveSelection,
  expiresAt,
  isLive
}:
  {
    amountCents: string,
    useFixedAmount: boolean,
    bulkCustomers: ((string | number)[])[],
    paymentMethods: string[],
    saveSelection: boolean,
    expiresAt: string,
    isLive: boolean
  }) => {

  const params = {
    amount_cents: amountCents,
    use_amount: useFixedAmount,
    use_reference_id: false,
    bulk_customers: bulkCustomers,
    payment_methods: paymentMethods,
    save_selection: saveSelection,
    expires_at: expiresAt,
    is_live: isLive
  };

  const capHeaders = await getCapHeadersConfig();

  return axiosPrivate.post(`/dashboard/api/v1/payment-links/bulk`, params, capHeaders);
};